import { Editor, Text, Element, Transforms } from 'slate';
import { isTopLevel } from '..';
const reCheckbox = /\* \[[ |x]\] /;
export function setListItemCheckbox(editor, checked, at) {
    if (at.length === 0) {
        throw new Error('at.length === 0');
    }
    const topLevelElementIndex = at[0];
    const topLevelElement = editor.children[topLevelElementIndex];
    if (!Element.isElement(topLevelElement) || !isTopLevel(topLevelElement)) {
        return;
    }
    const parentMdast = topLevelElement.parentMdastNode;
    if ((parentMdast === null || parentMdast === void 0 ? void 0 : parentMdast.type) !== 'listItem' || parentMdast.checked == null) {
        return;
    }
    const textNode = topLevelElement.children[0].children[0];
    if (!Text.isText(textNode)) {
        return;
    }
    const textPath = [topLevelElementIndex, 0, 0];
    const textStr = textNode.text;
    const replacedTextStr = textStr.replace(reCheckbox, checked ? '* [x] ' : '* [ ] ');
    const selection = editor.selection;
    Editor.withoutNormalizing(editor, () => {
        editor.apply({
            type: 'remove_text',
            path: textPath,
            offset: 0,
            text: textStr,
        });
        editor.apply({
            type: 'insert_text',
            path: textPath,
            offset: 0,
            text: replacedTextStr,
        });
        selection && Transforms.setSelection(editor, selection);
    });
}
//# sourceMappingURL=setListItemCheckbox.js.map